import { captureMessage } from '@sentry/react';

const alertError = (message: string) => captureMessage(`AlertError: ${message}`);

export default alertError;
